<!--
     <FieldImage>
-->

<template>
  <div >
    <v-tooltip bottom v-if="title">
      <template v-slot:activator="{ on, attrs }">
        <div style="width: fit-content;">
          <v-img
            v-if="!error"
            v-bind="attrs"
            v-on="on"
            max-width="100px"
            :src="representation"
            contain
            @click.stop="downloadImage"
            class="downloadable_image"
            @error="error = true"
          />
          <!--<div 
            
          >-->
            <v-btn
              v-else
              v-bind="attrs"
              v-on="on"
              big
              icon
              @click.stop="downloadImage"
            >
              <v-icon 
                big
              >
                mdi-download
              </v-icon>
            </v-btn>
          <!--</div>-->
        </div>
      </template>
      <span>{{ title }}</span>
    </v-tooltip>
  </div>
</template>

<style>
  .downloadable_image {
    cursor: pointer;
  }
  .fieldfile-icon:after{
    height: unset !important;
  }
</style>
  
<script>
  export default {
    name: 'FieldImage',
  
    props: ['field'],

    data(){
      return {
        no_image: require('../../assets/image_not_found.png'),
        error: false,
      }
    },
  
    computed: {
      representation() {
        return !this.error && this.field.props.thumbnail_path ? this.field.props.thumbnail_path : this.no_image
      },
      title() {
        return this.field.props.filename
      },
    },
    methods:{
      downloadImage(){
        this.$emit('download-evidence', this.field)
      },
    },
  };
</script>